module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"creative_space":"创作空间","my_work":"我的作品","breakdown_learning":"拆文学习","must_read":"入门必看","hot_tips":"爆款窍门","practical_video":"实操视频"},"en":{"creative_space":"Creative Space","my_work":"My Work","breakdown_learning":"Breakdown Learning","must_read":"Getting Started","hot_tips":"Hot Tips","practical_video":"Practical Video"}}')
  delete Component.options._Ctor
}
